// src/components/home/Testimonials.jsx
import React from 'react';
import { motion } from 'framer-motion';

const Testimonials = () => {
  return (
    <section className="bg-dark py-16 text-white">
      <div className="container mx-auto text-center">
        <motion.h2
          className="text-3xl font-heading font-bold mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          What Our Students Say
        </motion.h2>
        <div className="flex flex-wrap justify-center gap-8">
          <motion.div
            className="bg-light p-6 rounded-lg shadow-lg w-80"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <p className="text-lg text-gray-800 mb-4">"The course content was so thorough, and the instructors were extremely knowledgeable. I passed the FMGE with confidence!"</p>
            <p className="font-semibold">John Doe</p>
            <p className="text-sm text-gray-600">FMGE Aspirant</p>
          </motion.div>
          <motion.div
            className="bg-light p-6 rounded-lg shadow-lg w-80"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <p className="text-lg text-gray-800 mb-4">"The personalized study plan helped me focus on my weak areas, and I scored higher than I expected in NEET PG!"</p>
            <p className="font-semibold">Jane Smith</p>
            <p className="text-sm text-gray-600">NEET PG Aspirant</p>
          </motion.div>
          <motion.div
            className="bg-light p-6 rounded-lg shadow-lg w-80"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <p className="text-lg text-gray-800 mb-4">"The mock tests were incredibly helpful in simulating the actual exam environment. It reduced my anxiety significantly."</p>
            <p className="font-semibold">Alice Brown</p>
            <p className="text-sm text-gray-600">AIIMS PG Aspirant</p>
          </motion.div>
          <motion.div
            className="bg-light p-6 rounded-lg shadow-lg w-80"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <p className="text-lg text-gray-800 mb-4">"I appreciated the doubt-clearing sessions. The faculty were always ready to assist and explain concepts in detail."</p>
            <p className="font-semibold">David Lee</p>
            <p className="text-sm text-gray-600">PGI Chandigarh Aspirant</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;